const TTL_MS = 60 * 1000;
const MAX_KEYS = 1000;
const seenEvents = new Map();

const pruneExpired = (now) => {
  for (const [key, expiry] of seenEvents.entries()) {
    if (expiry > now) {
      break;
    }
    seenEvents.delete(key);
  }
};

export const markSeen = (key) => {
  if (!key) {
    return true;
  }

  const now = Date.now();
  pruneExpired(now);

  if (seenEvents.has(key)) {
    const expiry = seenEvents.get(key);
    if (expiry > now) {
      return false;
    }
    seenEvents.delete(key);
  }

  seenEvents.set(key, now + TTL_MS);
  if (seenEvents.size > MAX_KEYS) {
    const oldestKey = seenEvents.keys().next().value;
    if (oldestKey !== undefined) {
      seenEvents.delete(oldestKey);
    }
  }
  return true;
};

export const buildEventDedupKey = (eventType, payload = {}) => {
  if (!eventType) {
    return null;
  }
  const base =
    payload.notificationId ||
    payload.requestId ||
    payload.traceId ||
    payload.consultTraceId;
  if (!base) {
    return null;
  }
  return `${eventType}:${String(base)}`;
};



// WEBPACK FOOTER //
// ./src/utils/eventDedup.js